import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseSectionEditComponent } from '../base-section-edit/base-section-edit.component';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SectionService } from 'src/app/services/section.service';
import { fuseAnimations } from '@mobileia/layout-fuse';

@Component({
  selector: 'app-section-edit-four',
  templateUrl: './section-edit-four.component.html',
  styleUrls: ['./section-edit-four.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SectionEditFourComponent extends BaseSectionEditComponent implements OnInit {

  constructor(
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router,
    protected service: SectionService
  ) {
    super(alertService, route, navigator, service);
    this.initFields();
  }

  initFields() {
    this.configFields = [
      {
        type: 'string',
        key: 'last_date',
        title: 'Ultima Modificación',
        caption: ''
      },
      {
        type: 'string',
        key: 'url_pdf',
        title: 'URL para Descargar PDF',
        caption: ''
      },
      {
        type: 'list',
        key: 'list',
        title: 'Listado',
        caption: ''
      }
    ];
  }

  addBox() {
    this.item.data.list.push({ title: '', items: [] });
  }

  addBoxIntern(section) {
    section.items.push({ title: '', caption: '' });
  }

}
